/**
 * @generated SignedSource<<0fa452e4db125e8bcb5c1afe206df125>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PreviewOccurrenceReminderInput = {
  occurrenceId: string;
  richEditorBody: string;
  subject: string;
};
export type EventReminderPreviewEmailButtonMutation$variables = {
  input: PreviewOccurrenceReminderInput;
};
export type EventReminderPreviewEmailButtonMutation$data = {
  readonly response: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type EventReminderPreviewEmailButtonMutation = {
  response: EventReminderPreviewEmailButtonMutation$data;
  variables: EventReminderPreviewEmailButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PreviewOccurrenceReminderResponse",
    "kind": "LinkedField",
    "name": "previewOccurrenceReminder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventReminderPreviewEmailButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventReminderPreviewEmailButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "08b3ff24f163539d049834427996d4dc",
    "id": null,
    "metadata": {},
    "name": "EventReminderPreviewEmailButtonMutation",
    "operationKind": "mutation",
    "text": "mutation EventReminderPreviewEmailButtonMutation(\n  $input: PreviewOccurrenceReminderInput!\n) {\n  response: previewOccurrenceReminder(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ac3786ef0ad6c9ec769ddc0e9781c9f";

export default node;
